import React from 'react';

// iOS/SF Symbols 风格：统一的线性图标（圆角端点/拐角、统一线宽）
export const IOSIcon = ({ className, children, ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {children}
  </svg>
);

export const IconPrev = (p) => (
  <IOSIcon {...p}>
    <path d="M7 6v12" />
    <path d="M19 6L9 12l10 6V6z" />
  </IOSIcon>
);

export const IconNext = (p) => (
  <IOSIcon {...p}>
    <path d="M17 6v12" />
    <path d="M5 6l10 6-10 6V6z" />
  </IOSIcon>
);

// 视频图标组件（明显的视频文件图标）
export const IconVideo = (p) => (
  <svg {...p} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
  </svg>
);

export const IconPlay = (p) => (
  <IOSIcon {...p}>
    <path d="M9 7l10 5-10 5V7z" />
  </IOSIcon>
);

export const IconPause = (p) => (
  <IOSIcon {...p}>
    <path d="M9 7v10" />
    <path d="M15 7v10" />
  </IOSIcon>
);

// eslint-disable-next-line no-unused-vars
export const IconList = (p) => (
  <IOSIcon {...p}>
    <path d="M7 7h14" />
    <path d="M7 12h14" />
    <path d="M7 17h14" />
    <path d="M3 7h.01" />
    <path d="M3 12h.01" />
    <path d="M3 17h.01" />
  </IOSIcon>
);

// 顺序播放：在列表图标上叠加一个“播放三角形”（示意：list + play overlay）
export const IconListPlay = (p) => (
  <IOSIcon {...p}>
    <path d="M7 7h14" />
    <path d="M7 12h14" />
    <path d="M7 17h14" />
    <path d="M3 7h.01" />
    <path d="M3 12h.01" />
    <path d="M3 17h.01" />
    {/* overlay play triangle */}
    <g transform="translate(12 12) scale(2.3) translate(-12 -12)">
      <path
        d="M9.2 8.4L17 12l-7.8 3.6V8.4z"
        fill="currentColor"
        stroke="none"
      />
    </g>
  </IOSIcon>
);

export const IconShuffle = (p) => (
  <IOSIcon {...p}>
    <path d="M16 3h5v5" />
    <path d="M4 20l6-6" />
    <path d="M4 4l6 6" />
    <path d="M10 14l2 2" />
    <path d="M14 8l7-7" />
    <path d="M16 21h5v-5" />
    <path d="M14 16l7 7" />
  </IOSIcon>
);

export const IconRepeat = (p) => (
  <IOSIcon {...p}>
    <path d="M17 2l4 4-4 4" />
    <path d="M3 11V9a4 4 0 014-4h14" />
    <path d="M7 22l-4-4 4-4" />
    <path d="M21 13v2a4 4 0 01-4 4H3" />
  </IOSIcon>
);

// eslint-disable-next-line no-unused-vars
export const IconSliders = (p) => (
  <IOSIcon {...p}>
    <path d="M4 6h10" />
    <path d="M18 6h2" />
    <path d="M14 6v0" />
    <path d="M4 12h2" />
    <path d="M10 12h10" />
    <path d="M6 12v0" />
    <path d="M4 18h8" />
    <path d="M16 18h4" />
    <path d="M12 18v0" />
    <circle cx="14" cy="6" r="2" />
    <circle cx="6" cy="12" r="2" />
    <circle cx="12" cy="18" r="2" />
  </IOSIcon>
);

// eslint-disable-next-line no-unused-vars
export const IconGear = (p) => (
  <IOSIcon {...p}>
    {/* 外圈齿轮：留出更大中空区域，避免小尺寸下挤压变形 */}
    <path d="M19.2 12a7.2 7.2 0 00-.08-1l2.02-1.5-1.9-3.3-2.44 1a7.4 7.4 0 00-1.72-1l-.38-2.6h-3.8l-.38 2.6a7.4 7.4 0 00-1.72 1l-2.44-1-1.9 3.3L4.88 11a7.2 7.2 0 000 2l-2.02 1.5 1.9 3.3 2.44-1a7.4 7.4 0 001.72 1l.38 2.6h3.8l.38-2.6a7.4 7.4 0 001.72-1l2.44 1 1.9-3.3L19.12 13c.05-.33.08-.66.08-1z" />
    {/* 中心点：更小的实心圆点，给齿轮留出更多空间 */}
    <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
  </IOSIcon>
);

// 设置：新齿轮图标（18齿，带圆角矩形背景）
// 原 SVG 是 100x100，转换为 24x24 viewBox
export const IconTools = (p) => {
  // 缩放比例：24/100 = 0.24
  const scale = 0.24;
  const centerX = 12; // 24/2
  const centerY = 12; // 24/2

  // 生成18个齿轮齿（每20度一个，360/18=20）
  const teeth = [];
  for (let i = 0; i < 18; i++) {
    const angle = i * 20;
    // 原始坐标（基于100x100）
    // M0 -32 L-4 -38 H4 L0 -32 Z
    // 转换为24x24坐标
    const x0 = 0;
    const y0 = -32 * scale;
    const x1 = -4 * scale;
    const y1 = -38 * scale;
    const x2 = 4 * scale;

    teeth.push(
      <path
        key={i}
        d={`M${centerX + x0} ${centerY + y0} L${centerX + x1} ${centerY + y1} H${centerX + x2} L${centerX + x0} ${centerY + y0} Z`}
        fill="currentColor"
        transform={`rotate(${angle} ${centerX} ${centerY})`}
      />
    );
  }

  return (
    <svg
      className={p.className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...p}
    >
      {/* 圆角矩形背景 (100x100 -> 24x24, rx=22 -> 5.28) */}
      <rect x="0" y="0" width="24" height="24" rx="5.28" fill="currentColor" opacity="0.15" />
      {/* 齿轮齿 */}
      <g>{teeth}</g>
      {/* 外圆 (r=30 -> 7.2) */}
      <circle cx={centerX} cy={centerY} r={30 * scale} stroke="currentColor" strokeWidth={4.5 * scale} fill="none" />
      {/* 中心圆点 (r=7 -> 1.68) */}
      <circle cx={centerX} cy={centerY} r={7 * scale} fill="currentColor" />
    </svg>
  );
};

export const IconLyrics = (p) => (
  <IOSIcon {...p}>
    <path d="M21 15a4 4 0 01-4 4H9l-4 3v-3H7a4 4 0 01-4-4V7a4 4 0 014-4h10a4 4 0 014 4v8z" />
    <path d="M8 8h8" />
    <path d="M8 12h6" />
  </IOSIcon>
);

export const IconDownload = (p) => (
  <IOSIcon {...p}>
    <path d="M12 3v10" />
    <path d="M8 10l4 4 4-4" />
    <path d="M5 21h14" />
  </IOSIcon>
);

export const IconShare = (p) => (
  <IOSIcon {...p}>
    <path d="M12 3v10" />
    <path d="M8 6l4-3 4 3" />
    <path d="M5 10v10a1 1 0 001 1h12a1 1 0 001-1V10" />
  </IOSIcon>
);

export const IconQueue = (p) => (
  <IOSIcon {...p}>
    <path d="M4 6h16" />
    <path d="M4 12h10" />
    <path d="M4 18h16" />
    <path d="M18 10v4" />
    <path d="M16 12h4" />
  </IOSIcon>
);

export const IconVolume = (p) => (
  <IOSIcon {...p}>
    <path d="M11 5L7 9H4v6h3l4 4V5z" />
    <path d="M15 9a3 3 0 010 6" />
    <path d="M17.5 7a6 6 0 010 10" />
  </IOSIcon>
);

export const IconMute = (p) => (
  <IOSIcon {...p}>
    <path d="M11 5L7 9H4v6h3l4 4V5z" />
    <path d="M16 10l4 4" />
    <path d="M20 10l-4 4" />
  </IOSIcon>
);

export const IconFullscreen = (p) => (
  <IOSIcon {...p}>
    <path d="M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3" />
  </IOSIcon>
);

export const IconFullscreenExit = (p) => (
  <IOSIcon {...p}>
    <path d="M8 3v3a2 2 0 01-2 2H3m18 0h-3a2 2 0 01-2-2V3m0 18v-3a2 2 0 012-2h3M3 16h3a2 2 0 012 2v3" />
  </IOSIcon>
);

